import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  ErrorHandler,
  afterRenderEffect,
  computed,
  inject,
  input,
  resource,
} from '@angular/core';
import { loadIcon } from './icon-loader';
import type { IconName } from './icon-name';
import { SvgIconRenderer } from './svg-icon-renderer.service';

@Component({
  selector: 'pinnakl-icon',
  template: '',
  styleUrl: './pinnakl-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.width.px]': 'validSize()',
    '[style.height.px]': 'validSize()',
    'aria-hidden': 'true',
  },
})
export class PinnaklIconComponent {
  private readonly host = inject<ElementRef<HTMLElement>>(ElementRef).nativeElement;
  private readonly renderer = inject(SvgIconRenderer);
  private readonly errors = inject(ErrorHandler);
  private readonly icon = resource({
    params: () => this.name() || undefined,
    loader: ({ params }) => loadIcon(params),
  });

  readonly name = input<IconName | null>();
  readonly size = input<number>();
  protected readonly validSize = computed(() => {
    const size = this.size();
    return size !== undefined && Number.isFinite(size) && size > 0 ? size : null;
  });

  constructor() {
    afterRenderEffect({
      write: () => {
        this.host.replaceChildren();
        try {
          const error = this.icon.error();
          if (error) throw error;
          const icon = this.icon.value();
          if (!icon) return;
          this.renderer.render(icon, this.host);
        } catch (error) {
          this.errors.handleError(error);
        }
      },
    });
  }
}
